module.exports = __webpack_public_path__ + "asset/backImg01_2WA0sA9_.png";